export const SET_OPEN_MODAL_PLANILHA_DIESEL = "SET_OPEN_MODAL_PLANILHA_DIESEL";
export const SET_OPEN_MODAL_PLANILHA_IR_PENSAO_ALIMENTICIA = "SET_OPEN_MODAL_PLANILHA_IR_PENSAO_ALIMENTICIA";
export const SET_OPEN_MODAL_VERBAS_COMUNICADO = "SET_OPEN_MODAL_VERBAS_COMUNICADO";
export const SET_OPEN_MODAL_SUBVENCOES = "SET_OPEN_MODAL_SUBVENCOES";
export const SET_OPEN_MODAL_REVISOR = "SET_OPEN_MODAL_REVISOR";
export const SET_OPEN_MODAL_REVISOR_BLOQUEIO = "SET_OPEN_MODAL_REVISOR_BLOQUEIO";
export const SET_OPEN_MODAL_BLOQUEIO_MODULO = "SET_OPEN_MODAL_BLOQUEIO_MODULO";
export const SET_OPEN_MODAL_TERCEIROS_INFORMATIVO = "SET_OPEN_MODAL_TERCEIROS_INFORMATIVO";
export const SET_OPEN_MODAL_TERCEIROS_VIDEO = "SET_OPEN_MODAL_TERCEIROS_VIDEO";
export const SET_REDIRECT_TERCEIROS = "SET_REDIRECT_TERCEIROS";

